// @flow
import * as React from 'react';
import { sprintf } from 'sprintf-js';
import Box from 'components/Box';
import Meter from 'components/Meter';
import { BodyMicro } from 'components/Text';

const FundingMeter = ({
  current,
  total,
  dollars,
  signatures,
  ...props
}: {
  current: number,
  total: number,
  dollars?: boolean,
  signatures?: boolean
}) => {
  const roundedTotal = Math.round(total);
  const roundedCurrent = Math.round(current);

  return (
    <Box {...props}>
      <Box textAlign="right" color="battleshipGrey" mb="4px">
        <BodyMicro>
          {sprintf(
            dollars
              ? /* TRANSLATORS: remaining amount for volop to be funded */ getText(
                  '$%(remaining)s left'
                )
              : signatures
              ? /* TRANSLATORS: remaining signatures for petition */ getText(
                  '%(remaining)s signatures left'
                )
              : getText('%(remaining)s left'),
            {
              remaining: (roundedTotal - roundedCurrent).toLocaleString()
            }
          )}
        </BodyMicro>
      </Box>
      <Meter current={roundedCurrent} total={roundedTotal} />
    </Box>
  );
};

export default FundingMeter;
